import { DataCard } from '@/reports/shared/DataCard/DataCard';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { AutomobileRepairQuotes } from '@/reports/types/vehicles';
import { getHowItWorksContent } from '@/reports/vehicle/utils';
import { Text } from '@/theme/index';
import { pluralizeString } from '@/utils/index';
import { VehicleRepairQuoteCard } from './VehicleRepairQuoteCard/VehicleRepairQuoteCard';

interface VehicleRepairQuotesProps {
  vehicleRepairQuotesList: AutomobileRepairQuotes;
}

export function VehicleRepairQuotes({
  vehicleRepairQuotesList,
}: VehicleRepairQuotesProps) {
  const title = `${vehicleRepairQuotesList.length} Repair ${pluralizeString(
    'Quote',
    vehicleRepairQuotesList.length
  )} Reported`;
  const howItWorksCTAContent = getHowItWorksContent('Repair Quotes');

  return (
    <DataCard testId="vehicle-repair-quotes-section">
      <Text data-cy="report-section-title-text" variant="h2">
        {title}
      </Text>
      {vehicleRepairQuotesList &&
        vehicleRepairQuotesList.map((repairQuote, index) => (
          <VehicleRepairQuoteCard key={index} repairQuote={repairQuote} />
        ))}
      {vehicleRepairQuotesList?.length === 0 && (
        <>
          <EmptyVehicleSectionDisclaimer title="repair quotes" />
          {howItWorksCTAContent}
        </>
      )}
    </DataCard>
  );
}
